import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RxFormGroup } from "@rxweb/reactive-form-validators";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class ReportDailiesService {
	baseUrl = `${environment.apis.base}/routeros/report-dailies`;

	constructor(private readonly http: HttpClient) {}

	datatable(page?: number, options: any = {}): Observable<any> {
		let httpParams = new HttpParams();

		if (typeof page === "number") {
			httpParams = httpParams.append("page", page);
		}

		if ("key" in options && options.key.trim() !== "") {
			httpParams = httpParams.append("search", options.key);
		}

		return this.http.get<any>(this.baseUrl, { params: httpParams });
	}

	getAll(): Promise<any> {
		return this.http.get<any>(this.baseUrl).toPromise();
	}

	show(id: number): Promise<any> {
		const url = `${this.baseUrl}/${id}`;
		return this.http.get<any>(url).toPromise();
	}

	createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
		let url = this.baseUrl;

		if (id) {
			url += `/${id}`;
			return this.http.put<any>(url, data.value);
		} else {
			return this.http.post<any>(url, data.value);
		}
	}

	delete(id: number): Observable<any> {
		const url = `${this.baseUrl}/${id}`;
		return this.http.delete<any>(url);
	}
	getKPI(data: any): Promise<any> {
		const url = `${environment.apis.base}/media-views/reporte`;
		return this.http.post<any>(url, data).toPromise();
	}
	downloadKPI(data: any): Promise<HttpResponse<Blob>> {
		const url = `${environment.apis.base}/media-views/reporte-word`;

		return this.http
			.post(url, data, {
				responseType: "blob",
				observe: "response",
			})
			.toPromise();
	}
	downloadKPIPPT(data: any): Promise<HttpResponse<Blob>> {
		const url = `${environment.apis.base}/media-views/reporte-ppt`;

		return this.http
			.post(url, data, {
				responseType: "blob",
				observe: "response",
			})
			.toPromise();
	}
	downloadReportUnits(data:any): Promise<HttpResponse<Blob>> {
		const url = `${environment.apis.base}/media-views/reporte-word-funcionamiento-unidades`;

		return this.http
			.post(url, data, {
				responseType: "blob",
				observe: "response",
			})
			.toPromise();
	}
}
